export const TutorAvatar = ({ speaking, size = "w-20 h-20 sm:w-24 sm:h-24" }) => (
  <div className="relative inline-block" data-testid="tutor-avatar">
    <img
      src="/mascot.png"
      alt="Mia, your study coach"
      className={`${size} rounded-full border-4 border-black object-cover shadow-[4px_4px_0px_rgba(0,0,0,1)] bg-white ${
        speaking ? "animate-bounce-soft" : ""
      }`}
    />
    {speaking && (
      <span className="absolute inset-0 rounded-full border-4 border-[#F2C6DE] animate-ping-slow pointer-events-none" />
    )}
    <span
      className={`absolute bottom-0.5 right-0.5 w-4 h-4 rounded-full border-2 border-black ${
        speaking ? "bg-[#FF6B6B]" : "bg-[#51CF66]"
      }`}
    />
  </div>
);
